import { useCallback, useLayoutEffect, useRef, useSyncExternalStore } from 'react';
import { useRuntimeDependency } from './useRuntimeDependency.js';
export function useInitializeUploadWidget(cloudName, uploadPreset, callback) {
    const { status } = useRuntimeDependency('cloudinary-upload-widget');
    const widgetRef = useRef(null);
    const listenersRef = useRef(new Set());
    const notify = () => {
        for (const listener of listenersRef.current)
            listener();
    };
    useLayoutEffect(() => {
        if (status !== 'ready') {
            return;
        }
        const { cloudinary } = window;
        const widget = cloudinary.createUploadWidget({
            cloudName,
            uploadPreset,
            sources: ['local', 'url', 'camera'],
            multiple: false,
            resourceType: 'image',
        }, callback);
        widgetRef.current = widget;
        notify();
        return () => {
            void widget.destroy();
            widgetRef.current = null;
            notify();
        };
        //TODO fix deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callback, status]);
    const subscribe = useCallback((onStoreChange) => {
        listenersRef.current.add(onStoreChange);
        return () => {
            listenersRef.current.delete(onStoreChange);
        };
    }, []);
    return useSyncExternalStore(subscribe, () => widgetRef.current, () => null);
}
//# sourceMappingURL=useInitializeUploadWidget.js.map